import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet, Linking, Image } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { useTheme } from '../contexts/ThemeContext';
import { useNavigation } from '@react-navigation/native';

const Footer = () => {
  const { colors } = useTheme();
  const navigation = useNavigation();

  const handleLinkPress = (url) => {
    Linking.openURL(url);
  };

  const handleNavigate = (screenName) => {
    navigation.navigate(screenName);
  };

  const styles = StyleSheet.create({
    footer: {
      backgroundColor: colors.surface,
      borderTopWidth: 1,
      borderTopColor: colors.border,
      paddingVertical: 40,
      paddingHorizontal: 20,
      width: '100%',
    },
    footerContent: {
      width: '100%',
      maxWidth: 1400,
      alignSelf: 'center',
    },
    footerTop: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      marginBottom: 30,
    },
    footerSection: {
      minWidth: 160,
      marginBottom: 20,
      paddingHorizontal: 10,
    },
    footerSectionLogo: {
      minWidth: 250,
      maxWidth: 280,
      marginBottom: 20,
      paddingHorizontal: 10,
    },
    footerTitle: {
      fontSize: 18,
      fontWeight: 'bold',
      color: colors.text,
      marginBottom: 15,
    },
    footerLogo: {
      height: 60,
      width: 180,
      resizeMode: 'contain',
      marginBottom: 15,
    },
    footerLink: {
      paddingVertical: 5,
    },
    footerLinkText: {
      fontSize: 14,
      color: colors.textSecondary,
      textDecorationLine: 'none',
    },
    footerDescription: {
      fontSize: 14,
      color: colors.textSecondary,
      lineHeight: 20,
      marginBottom: 15,
    },
    socialContainer: {
      flexDirection: 'row',
      marginTop: 10,
    },
    socialButton: {
      width: 40,
      height: 40,
      borderRadius: 20,
      backgroundColor: colors.primary,
      justifyContent: 'center',
      alignItems: 'center',
      marginHorizontal: 5,
    },
    footerBottom: {
      borderTopWidth: 1,
      borderTopColor: colors.border,
      paddingTop: 20,
      flexDirection: 'column',
      alignItems: 'center',
      gap: 15,
    },
    copyright: {
      fontSize: 12,
      color: colors.textSecondary,
      textAlign: 'center',
    },
    qodeyardLink: {
      fontSize: 12,
      color: colors.primary,
      textDecorationLine: 'underline',
    },
    footerBottomLinks: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'center',
      alignItems: 'center',
    },
    footerBottomLink: {
      marginHorizontal: 10,
      marginVertical: 5,
    },
    footerBottomLinkText: {
      fontSize: 12,
      color: colors.textSecondary,
    },
  });

  return (
    <View style={styles.footer}>
      <View style={styles.footerContent}>
        <View style={styles.footerTop}>
          {/* Logo Section */}
          <View style={styles.footerSectionLogo}>
            <Image
              source={require('../../assets/Modern-Munishiji-Logo-Transparent.png')}
              style={styles.footerLogo}
            />
            <Text style={styles.footerDescription}>
              From GST filing to ITR, RTO services, and business registrations — we ensure every financial and legal process is done accurately and on time. Let Modern Munshiji simplify your accounting journey.
            </Text>
            <View style={styles.socialContainer}>
              <TouchableOpacity
                style={styles.socialButton}
                onPress={() => handleLinkPress('https://facebook.com')}
              >
                <Ionicons name="logo-facebook" size={20} color="white" />
              </TouchableOpacity>
              <TouchableOpacity
                style={styles.socialButton}
                onPress={() => handleLinkPress('https://twitter.com')}
              >
                <Ionicons name="logo-twitter" size={20} color="white" />
              </TouchableOpacity>
              <TouchableOpacity
                style={styles.socialButton}
                onPress={() => handleLinkPress('https://linkedin.com')}
              >
                <Ionicons name="logo-linkedin" size={20} color="white" />
              </TouchableOpacity>
              <TouchableOpacity
                style={styles.socialButton}
                onPress={() => handleLinkPress('https://instagram.com')}
              >
                <Ionicons name="logo-instagram" size={20} color="white" />
              </TouchableOpacity>
            </View>
          </View>

          {/* Calculators Section */}
          <View style={styles.footerSection}>
            <Text style={styles.footerTitle}>Calculators</Text>
            <TouchableOpacity style={styles.footerLink} onPress={() => handleNavigate('IncomeTaxCalculator')}>
              <Text style={styles.footerLinkText}>Income Tax Calculator</Text>
            </TouchableOpacity>
            <TouchableOpacity style={styles.footerLink} onPress={() => handleNavigate('SIPCalculator')}>
              <Text style={styles.footerLinkText}>SIP Calculator</Text>
            </TouchableOpacity>
            <TouchableOpacity style={styles.footerLink} onPress={() => handleNavigate('EMICalculator')}>
              <Text style={styles.footerLinkText}>EMI Calculator</Text>
            </TouchableOpacity>
            <TouchableOpacity style={styles.footerLink} onPress={() => handleNavigate('FDCalculator')}>
              <Text style={styles.footerLinkText}>FD Calculator</Text>
            </TouchableOpacity>
            <TouchableOpacity style={styles.footerLink} onPress={() => handleNavigate('PPFCalculator')}>
              <Text style={styles.footerLinkText}>PPF Calculator</Text>
            </TouchableOpacity>
          </View>

          {/* More Calculators Section (was Resources) */}
          <View style={styles.footerSection}>
            <Text style={styles.footerTitle}>More Calculators</Text>
            <TouchableOpacity style={styles.footerLink} onPress={() => handleNavigate('GSTCalculator')}>
              <Text style={styles.footerLinkText}>GST Calculator</Text>
            </TouchableOpacity>
            <TouchableOpacity style={styles.footerLink} onPress={() => handleNavigate('TDSCalculator')}>
              <Text style={styles.footerLinkText}>TDS Calculator</Text>
            </TouchableOpacity>
            <TouchableOpacity style={styles.footerLink} onPress={() => handleNavigate('HRACalculator')}>
              <Text style={styles.footerLinkText}>HRA Calculator</Text>
            </TouchableOpacity>
            <TouchableOpacity style={styles.footerLink} onPress={() => handleNavigate('GratuityCalculator')}>
              <Text style={styles.footerLinkText}>Gratuity Calculator</Text>
            </TouchableOpacity>
            <TouchableOpacity style={styles.footerLink} onPress={() => handleNavigate('CalculatorsHome')}>
              <Text style={[styles.footerLinkText, { color: colors.primary, fontWeight: '600' }]}>View All →</Text>
            </TouchableOpacity>
          </View>

          {/* Tools Section (was Documentation) */}
          <View style={styles.footerSection}>
            <Text style={styles.footerTitle}>Tools</Text>
            <TouchableOpacity style={styles.footerLink} onPress={() => handleNavigate('InvoiceGenerator')}>
              <Text style={styles.footerLinkText}>Invoice Generator</Text>
            </TouchableOpacity>
            <TouchableOpacity style={styles.footerLink} onPress={() => handleNavigate('QuotationMaker')}>
              <Text style={styles.footerLinkText}>Quotation Maker</Text>
            </TouchableOpacity>
            <TouchableOpacity style={styles.footerLink} onPress={() => handleNavigate('ToolsHome')}>
              <Text style={[styles.footerLinkText, { color: colors.primary, fontWeight: '600' }]}>View All Tools →</Text>
            </TouchableOpacity>
          </View>

          {/* Services Section */}
          <View style={styles.footerSection}>
            <Text style={styles.footerTitle}>Services</Text>
            <TouchableOpacity style={styles.footerLink} onPress={() => handleNavigate('GSTFiling')}>
              <Text style={styles.footerLinkText}>GST Filing</Text>
            </TouchableOpacity>
            <TouchableOpacity style={styles.footerLink} onPress={() => handleNavigate('ITRFiling')}>
              <Text style={styles.footerLinkText}>ITR Filing</Text>
            </TouchableOpacity>
            <TouchableOpacity style={styles.footerLink} onPress={() => handleNavigate('BusinessRegistration')}>
              <Text style={styles.footerLinkText}>Business Registration</Text>
            </TouchableOpacity>
            <TouchableOpacity style={styles.footerLink} onPress={() => handleNavigate('RTOServices')}>
              <Text style={styles.footerLinkText}>RTO Services</Text>
            </TouchableOpacity>
          </View>

          {/* Support Section */}
          <View style={styles.footerSection}>
            <Text style={styles.footerTitle}>Support</Text>
            <TouchableOpacity style={styles.footerLink} onPress={() => handleNavigate('HelpCenter')}>
              <Text style={styles.footerLinkText}>Help Center</Text>
            </TouchableOpacity>
            <TouchableOpacity style={styles.footerLink} onPress={() => handleNavigate('Contact')}>
              <Text style={styles.footerLinkText}>Contact Us</Text>
            </TouchableOpacity>
            <TouchableOpacity style={styles.footerLink} onPress={() => handleNavigate('FAQ')}>
              <Text style={styles.footerLinkText}>FAQ</Text>
            </TouchableOpacity>
            <TouchableOpacity style={styles.footerLink} onPress={() => handleNavigate('Feedback')}>
              <Text style={styles.footerLinkText}>Feedback</Text>
            </TouchableOpacity>
            <TouchableOpacity style={styles.footerLink} onPress={() => handleNavigate('ReportIssue')}>
              <Text style={styles.footerLinkText}>Report Issue</Text>
            </TouchableOpacity>
          </View>
        </View>

        <View style={styles.footerBottom}>
          <Text style={styles.copyright}>
            © 2025 ModernMunshiji. All rights reserved. Design & Maintain by{' '}
            <Text
              style={styles.qodeyardLink}
              onPress={() => handleLinkPress('https://qodeyard.com')}
            >
              Qodeyard
            </Text>
          </Text>
          <View style={styles.footerBottomLinks}>
            <TouchableOpacity
              style={styles.footerBottomLink}
              onPress={() => handleNavigate('PrivacyPolicy')}
            >
              <Text style={styles.footerBottomLinkText}>Privacy Policy</Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={styles.footerBottomLink}
              onPress={() => handleNavigate('TermsOfService')}
            >
              <Text style={styles.footerBottomLinkText}>Terms of Service</Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={styles.footerBottomLink}
              onPress={() => handleNavigate('Disclaimer')}
            >
              <Text style={styles.footerBottomLinkText}>Disclaimer</Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </View>
  );
};

export default Footer;